import {
  OrderStatusEnum,
  BIDDING_STATUSES,
  WAITING_STATUSES,
  FINISH_STATUSES,
} from '../configs/order-statuses.enum';

/**
 * Проверяет, является ли статус валидным
 */
export const isValidOrderStatus = (status: string): status is OrderStatusEnum => {
  return Object.values(OrderStatusEnum).includes(status as OrderStatusEnum);
};

/**
 * Безопасно проверяет, является ли статус статусом торгов
 */
export const isBiddingStatus = (status: string): boolean => {
  return isValidOrderStatus(status) && BIDDING_STATUSES.includes(status);
};

/**
 * Безопасно проверяет, является ли статус статусом ожидания
 */
export const isWaitingStatus = (status: string): boolean => {
  return isValidOrderStatus(status) && WAITING_STATUSES.includes(status);
};

/**
 * Безопасно проверяет, является ли статус финальным статусом
 */
export const isFinishStatus = (status: string): boolean => {
  return isValidOrderStatus(status) && FINISH_STATUSES.includes(status);
};

/**
 * Безопасно проверяет, является ли статус новым
 */
export const isNewStatus = (status: string): boolean => {
  return isValidOrderStatus(status) && status === OrderStatusEnum.NEW;
};

/**
 * Безопасно проверяет, является ли статус приостановленным
 */
export const isPausedStatus = (status: string): boolean => {
  return (
    isValidOrderStatus(status) &&
    (status === OrderStatusEnum.PAUSED || status === OrderStatusEnum.PAUSED_LOCK)
  );
};

/**
 * Безопасно проверяет, является ли статус заблокированным приостановленным
 */
export const isPausedLockStatus = (status: string): boolean => {
  return isValidOrderStatus(status) && status === OrderStatusEnum.PAUSED_LOCK;
};

/**
 * Безопасно проверяет, является ли статус ожиданием подтверждения
 */
export const isWaitForConfirmStatus = (status: string): boolean => {
  return isValidOrderStatus(status) && status === OrderStatusEnum.WAIT_FOR_CONFIRM;
};

/**
 * Безопасно проверяет, является ли статус ожиданием торгов
 */
export const isWaitForTradeStatus = (status: string): boolean => {
  return isValidOrderStatus(status) && status === OrderStatusEnum.WAIT_FOR_TRADE;
};

/**
 * Безопасно проверяет, является ли статус ожиданием подтверждения торгов
 */
export const isWaitForTradeConfirmStatus = (status: string): boolean => {
  return isValidOrderStatus(status) && status === OrderStatusEnum.WAIT_FOR_TRADE_CONFIRM;
};

/**
 * Безопасно проверяет, является ли статус ожиданием принятия покупателем
 */
export const isWaitForBuyerAcceptStatus = (status: string): boolean => {
  return isValidOrderStatus(status) && status === OrderStatusEnum.WAIT_FOR_BUYER_ACCEPT;
};

/**
 * Безопасно проверяет, является ли статус созданным заказом
 */
export const isOrderCreatedStatus = (status: string): boolean => {
  return isValidOrderStatus(status) && status === OrderStatusEnum.ORDER_CRATED;
};

/**
 * Безопасно проверяет, является ли статус удержанным
 */
export const isHoldStatus = (status: string): boolean => {
  return isValidOrderStatus(status) && status === OrderStatusEnum.HOLD;
};

/**
 * Безопасно проверяет, является ли статус возвратом от продавца
 */
export const isRefundBySellerStatus = (status: string): boolean => {
  return isValidOrderStatus(status) && status === OrderStatusEnum.REFUND_BY_SELLER;
};

/**
 * Безопасно проверяет, является ли статус заблокированным удаленным
 */
export const isDeletedLockStatus = (status: string): boolean => {
  return isValidOrderStatus(status) && status === OrderStatusEnum.DELETED_LOCK;
};

/**
 * Получает безопасный статус или fallback
 */
export const getSafeOrderStatus = (
  status: string,
  fallback: OrderStatusEnum = OrderStatusEnum.NEW
): OrderStatusEnum => {
  return isValidOrderStatus(status) ? (status as OrderStatusEnum) : fallback;
};
